import { render, staticRenderFns } from "./SpeedChart.vue?vue&type=template&id=049c5fb0&scoped=true&"
import script from "./SpeedChart.vue?vue&type=script&lang=js&"
export * from "./SpeedChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049c5fb0",
  null
  
)

export default component.exports